import { IconProps } from ".";

export const CheckRadioIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99996 2.91675C6.08794 2.91675 2.91663 6.08806 2.91663 10.0001C2.91663 13.9121 6.08794 17.0834 9.99996 17.0834C13.912 17.0834 17.0833 13.9121 17.0833 10.0001C17.0833 6.08806 13.912 2.91675 9.99996 2.91675ZM1.66663 10.0001C1.66663 5.39771 5.39759 1.66675 9.99996 1.66675C14.6023 1.66675 18.3333 5.39771 18.3333 10.0001C18.3333 14.6025 14.6023 18.3334 9.99996 18.3334C5.39759 18.3334 1.66663 14.6025 1.66663 10.0001ZM12.8957 7.43302C13.1629 7.6516 13.2023 8.04537 12.9837 8.31252L9.23368 12.8959C9.12187 13.0325 8.95745 13.1155 8.78109 13.1243C8.60473 13.1331 8.43288 13.0669 8.30802 12.942L6.64135 11.2754C6.39727 11.0313 6.39727 10.6356 6.64135 10.3915C6.88543 10.1474 7.28116 10.1474 7.52523 10.3915L8.70356 11.5698L12.0162 7.52097C12.2348 7.25382 12.6286 7.21445 12.8957 7.43302Z"
        fill="currentColor"
      />
    </svg>
  );
};

// #40BA6F
